import App from './App.svelte';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, getString, fetchAndActivate, } from 'firebase/remote-config';
const firebaseConfig = {
    apiKey: "AIzaSyAOdDwuAx-aCCiCyp3Xna51kBOMfEGCAqI",
    authDomain: "dev-whatspp-pay.firebaseapp.com",
    projectId: "dev-whatspp-pay",
    storageBucket: "dev-whatspp-pay.appspot.com",
    messagingSenderId: "334872853909",
    appId: "1:334872853909:web:f7e3020653b3d8cb400a9c",
    measurementId: "G-CJSC4QMDFQ",
};
let app;
const firebaseApp = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
fetch('./static/remote_config_defaults.json').then(rcDefaultsFile => {
    rcDefaultsFile.json().then(rcDefaultsJson => {
        remoteConfig.defaultConfig = rcDefaultsJson;
        fetchAndActivate(remoteConfig).then(() => {
            const enabledButtons = JSON.parse(getString(remoteConfig, 'enabled_buttons'));
            const buttonLinks = JSON.parse(getString(remoteConfig, 'button_links'));
            app = new App({
                target: document.body,
                props: {
                    enabledButtons: enabledButtons,
                    buttonLinks: buttonLinks,
                }
            });
        }).catch((_) => {
            const enabledButtons = JSON.parse(getString(remoteConfig, 'enabled_buttons'));
            app = new App({
                target: document.body,
                props: {
                    enabledButtons: enabledButtons
                }
            });
        });
    });
});
export default app;
